import { HandoverErrorType, ThreadControlErrorType } from 'apps/chat/constants/LiveChatInterfaces'
import { ProProduct } from 'common/core/interfaces/products'
import { BusinessError } from 'shared/api/lib/errors/business'

export interface HopError extends BusinessError {
  error_data: {
    hop_error: {
      counter: number
      type: HandoverErrorType
    }
  }
}

export interface ThreadControlError extends BusinessError {
  error_data: {
    thread_control_error: {
      counter: number
      type: ThreadControlErrorType
      subscriber_id: string
    }
  }
}

interface GoProError extends BusinessError {
  error_data: {
    go_pro: boolean
    products: ProProduct[]
  }
}

interface IAddLinkToDevLog extends BusinessError {
  error_data: {
    add_link_to_dev_log: boolean
  }
}

const isHopError = (error: BusinessError): error is HopError =>
  error?.error_data?.hop_error !== undefined

const isThreadControlError = (error: BusinessError): error is ThreadControlError =>
  error?.error_data?.thread_control_error !== undefined

const isGoProError = (error: BusinessError): error is GoProError =>
  error?.error_data?.go_pro !== undefined

const isAddLinkToDevLog = (error: BusinessError): error is IAddLinkToDevLog =>
  error?.error_data?.add_link_to_dev_log !== undefined

export const chatApiGuard = {
  isHopError,
  isThreadControlError,
  isGoProError,
  isAddLinkToDevLog,
}
